import "./Blog.css";
import author from "../../Images/Brand/Author.png";
import bigBlogImage from "../../Images/Blogs/blog.png";
import { BlogPreviewSingle, Ctabanner, Footer, Nav, Social } from "../../Components/ExportComponents";
import { useState } from "react";

// Title
const title = (text) => <div className="BlogTitleP">{text}</div>;

// Subtitle
const subtitle = (text) => <div className="subtitle">{text}</div>;

// Description (with dropcap effect applied via CSS)
const description = (text) => (
    <div className="description dropcap">{text}</div>
);

// Big Image
const bigImg = (src) => (
    <div className="big-img">
        <img src={src} alt="Big" />
    </div>
);

// Small Image (array of sources)
const smallImg = (sources) => (
    <div className="images">
        {sources.map((src, index) => (
            <div key={index} className="image-item">
                <img src={src} alt={` ${index + 1}`} />
            </div>
        ))}
    </div>
);

// List of text (unordered list style but using divs)
const list = (items) => (
    <div className="list">
        {items.map((item, index) => (
            <div key={index} className="list-item">
                <span></span>{item}
            </div>
        ))}
    </div>
);

// Conclusion
const conclusion = (text) => (
    <div className="conclusion">{text}</div>
);


const Blog = () => {
    const [menuBar, setMenuBar] = useState(false);
    return (
        <>
            <div className="backgroundBig">
                <span className="mainBackgroundHR"></span>
                <span className="mainBackgroundHRleft"></span>
                <div className="mainBackgroundHRRight"></div>
                <span className="mainBackgroundHRright"></span>
                <span className="mainBackgroundBig"></span>
                <span className="mainBackgroundBigRight"></span>

                <div className="smallBack">
                    <div className="topLeftInternal"></div>
                    <div className="topLeftInternal2"></div>

                    <div className="topRightInternal"></div>
                    <div className="topRightInternal2"></div>
                    <Nav setMenuBar={setMenuBar} menuBar={menuBar} />
                    <div className="blogPage">
                        <div className="blogPreview">
                            <div className="blogBb top20">
                                <div className="titleNdecsFr">
                                    <div className="titleHeadline">
                                        Blog
                                    </div>
                                    <div className="titleDesc">
                                        covering creativity, strategy, and the business side of design, strategy, marketing
                                    </div>
                                </div>
                                <div className="titleOfBlogP">
                                    A collection of experience-backed content that breaks down design principles, brand strategy, digital trends, and creative workflows
                                </div>
                                <div className="uProfile">
                                    <div className="left">
                                        <img src={author} alt="" />
                                    </div>
                                    <div className="right">
                                        <div className="name">Bhanubhakta_Sapkota</div>
                                        <div className="post">Graphic Designer</div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="blogPrev">

                            </div> */}


                        </div>
                        <div className="titleNDate">
                            <div className="titleProfile">
                                <div className="textScroll">
                                    <span>Graphic Design</span>
                                    <span>Graphic Design</span>
                                </div>
                            </div>
                            <div className="dateProfile">
                                <div className="textScroll">
                                    <span>2025</span>
                                    <span>2025</span>
                                </div>
                            </div>
                        </div>

                        <div className="blogComponents">
                            {bigImg(bigBlogImage)}
                            {title("Graphic Design")}
                            {subtitle("Graphic Design: A Complete Guide - Career, Scope, Earning, and the Future with AI")}
                            {description("Graphic Design is more than visuals - it’s communication,problem-solving, and brand-building. As a designer from Pokhara, Nepal working with global clients, I’ve seen how design shapes businesses, digital experiences, and audience perception. This blog breaks down what graphic design really is, its scope in Nepal and internationally, earning opportunities, and how AI is transforming (not replacing) the creative field.")}
                            {subtitle("Graphic Design: A Complete Guide - Career, Scope, Earning, and the Future with AI")}
                            {title("What is Graphic Design?")}
                            {description("Graphic Design is the practice of converting ideas into meaningful visuals. It blends creativity, strategy, and communication to help brands deliver messages through:")}
                            {list([
                                "Social media graphics",
                                "Posters, banners, flyers",
                                "Logo & branding systems",
                                "Packaging",
                                "Print and digital ads",
                                "Marketing materials"
                            ])}

                            {smallImg([bigBlogImage, bigBlogImage])}
                            {title("Scope of Graphic Design in Nepal")}
                            {description("Graphic design is growing rapidly in Nepal due to:")}
                            {list([
                                "Increasing number of startups",
                                "Expanding digital marketing industry",
                                "Higher demand for branding and social media design",
                                "Growth of agencies and online businesses",
                                "More freelancers working globally"
                            ])}
                            {title("Graphic Design & AI - A New Chapter")}
                            {description("AI has changed the way designers work:")}
                            {list([
                                "Faster idea generation",
                                "Quick mockups",
                                "Image enhancement",
                                "Video + motion assistance",
                                "Content automation"
                            ])}
                            {description("AI improves workflow, but does not replace actual designers. Why?")}
                            {description("Because real design requires:")}
                            {list([
                                "Strategy",
                                "Human emotion",
                                "Business understanding",
                                "Aesthetic judgment",
                                "Brand storytelling"
                            ])}
                            {title("Will AI Replace Graphic Designers?")}
                            {description("No AI will replace designers who only “decorate.” But designers who understand branding, storytelling, marketing, and strategy will always be in demand.")}
                            {description("The future designer  = Creative + Strategic + AI-powered That’s why building a strong personal brand (like The Visual Designer) gives you global visibility and advantage")}

                            {conclusion("")}
                        </div>
                        <div className="listBlogPreview margin5">
                            <BlogPreviewSingle />

                            <BlogPreviewSingle />
                        </div>
                        <Social />
                        <Ctabanner />
                        <Footer />
                    </div>
                </div>
            </div>
        </>
    )
}
export default Blog;